import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";

interface NavBarProps {
    mark: number;
    onChange: (val: number) => void;
}

export default function NavBar({ mark, onChange }: NavBarProps) {
    return (
        <div className={style.root}>
            <div className={style.links}>
                {/* <div className={classNames(style.link, {[style.current]: mark === 0})} onClick={()=>onChange(0)}>教学日志</div> */}
                <div
                    className={classNames(style.link, {
                        [style.current]: mark === 1
                    })}
                    onClick={() => onChange(1)}>
                    教学分析
                </div>
                <div
                    className={classNames(style.link, {
                        [style.current]: mark === 2
                    })}
                    onClick={() => onChange(2)}>
                    学情分析
                </div>
            </div>
        </div>
    );
}
